module.exports = __webpack_public_path__ + "components/flag/static/square/km-cf6f4b9958542753f88221584518016c.svg";